import axios from 'axios';
import BaseClient from '../base-client';
import SearchResultItem, { formatSearchResult } from './model';

/**
 * This function allows any NS in response to prevent
 * formatting errors at named queries responses
 * @param {*} ns the fallback ns response
 * @param {*} data the response object
 * @returns
 */
const genericNSFormatSearchResult = (ns, data = {}) => {
  const keys = Object.keys(data);
  if (keys.length === 1) {
    const [key] = keys;
    if (key.startsWith('collection_')) {
      const responseNS = key.replace('collection_', '');
      return formatSearchResult(responseNS, data);
    }
  }
  return formatSearchResult(ns, data);
};

export default class SearchClient extends BaseClient {
  constructor(options = {}) {
    super('search', {
      format: formatSearchResult,
      ...options,
    });
  }

  async search({
    target,
    entity,
    fields,
    filters,
    order,
    first = 0,
    size = 10,
    apicges,
    noresultsrowid,
    isPagination,
    priorityQuery,
  }) {
    let firstP = first;
    let sizeP = size;

    if (sizeP < 0 || sizeP > 25) {
      sizeP = 25;
    }

    if (firstP > sizeP) {
      firstP = 0;
    } else if (firstP < 0) {
      firstP = 0;
    }

    if (isPagination) {
      firstP = first;
      sizeP = size;
    }

    console.log('making search request', {
      target,
      entity,
      fields,
      filters,
      apicges,
      order,
      first: firstP,
      size: sizeP,
      noresultsrowid,
    });
    try {
      const response = await this.request('get')({
        target,
        entity,
        fields,
        filters,
        order,
        first: firstP,
        size: sizeP,
        apicges,
        noresultsrowid,
        priorityQuery,
      });

      this.$formatter = genericNSFormatSearchResult.bind(this, entity);

      return this.format(response);
    } catch (ex) {
      throw this.handleError(ex);
    }
  }

  cancelableSearch({
    target,
    entity,
    fields,
    filters,
    order,
    first = 0,
    size = 10,
    apicges,
    noresultsrowid,
    isPagination,
    priorityQuery,
  }) {
    let firstP = first;
    let sizeP = size;

    if (sizeP < 0 || sizeP > 25) {
      sizeP = 25;
    }

    if (firstP > sizeP) {
      firstP = 0;
    } else if (firstP < 0) {
      firstP = 0;
    }

    if (isPagination) {
      firstP = first;
      sizeP = size;
    }

    const cancelToken = axios.CancelToken.source();

    const req = this.request('get')({
      target,
      entity,
      fields,
      filters,
      order,
      first: firstP,
      size: sizeP,
      apicges,
      noresultsrowid,
      priorityQuery,
    }, {
      cancelToken: cancelToken.token,
    });

    req.cancel = () => {
      req.cancelled = true;
      cancelToken.cancel('Operation was cancelled by user interaction');
    };

    req.format = this.format.bind({
      $formatter: genericNSFormatSearchResult.bind(this, entity),
    });

    return req;
  }
}

export {
  SearchResultItem,
};
